.editorContainer {
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
}

.plateContent {
  display: flex;
  outline: none;
  flex-direction: column;
  flex: 1 1 auto;
  cursor: auto;
  position: relative;
}

/* Slate draws the placeholder with an inline opacity of 0.333 (2.05:1). Use the secondary text colour (4.5:1+). */
.plateContent [data-slate-placeholder='true'] {
  opacity: 1 !important;
  color: var(--tuna-content-secondary);
}

.editorContainer--gutter {
  padding: 0 32px;
}

@media (max-width: 599.95px) {
  .editorContainer--gutter {
    padding: 0 4px;
  }
}
